import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

/**
 * Get all modules
 * @returns {Promise} Modules list
 */
export const getAllModules = async () => {
  try {
    const response = await axiosInstance.get('/AccessManagement/modules');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Create a new module
 * @param {Object} moduleData - Module data { ModuleName, DisplayName, Description, Category }
 * @returns {Promise} Created module
 */
export const createModule = async (moduleData) => {
  try {
    const response = await axiosInstance.post('/AccessManagement/modules', moduleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update an existing module
 * @param {string} moduleId - Module ID
 * @param {Object} moduleData - Module data { ModuleName, DisplayName, Description, Category }
 * @returns {Promise} Updated module
 */
export const updateModule = async (moduleId, moduleData) => {
  try {
    const response = await axiosInstance.put(`/AccessManagement/modules/${moduleId}`, moduleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete a module
 * @param {string} moduleId - Module ID
 * @returns {Promise} Success message
 */
export const deleteModule = async (moduleId) => {
  try {
    const response = await axiosInstance.delete(`/AccessManagement/modules/${moduleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  getAllModules,
  createModule,
  updateModule,
  deleteModule,
};
